import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const SignupSuccessPage = lazy(() =>
  import('@/features/auth/signup/SignupSuccessPage').then((m) => ({ default: m.SignupSuccessPage })),
);

export const Route = createFileRoute('/sign-up/success')({
  component: () => (
    <Suspense>
      <SignupSuccessPage />
    </Suspense>
  ),
});
